import type { CategoryDefinition } from '@/types';

export const plumbingCategories: readonly CategoryDefinition[] = [
  { id: 'plumbing.repair',       name: 'Repair',       icon: 'wrench',       color: 'teal',    order: 1, description: 'Fault finding and fixes' },
  { id: 'plumbing.installation', name: 'Installation', icon: 'shower-head',  color: 'sky',     order: 2, description: 'New fittings and fixtures' },
  { id: 'plumbing.maintenance',  name: 'Maintenance',  icon: 'badge-check',  color: 'emerald', order: 3, description: 'Servicing and preventative work' },
  { id: 'plumbing.emergency',    name: 'Emergency',    icon: 'siren',        color: 'rose',    order: 4, description: 'Out-of-hours and same-day call-outs' },
];
